import { Box, Inline, Text } from 'braid-design-system';

export const Categories = ({ categories }: { categories: string[] }) => (
  <Inline space="xxsmall">
    {categories.map((category, index) => (
      <Box
        title={category}
        key={index}
        background="neutralLight"
        paddingY="xsmall"
        paddingX="small"
        borderRadius="full"
      >
        <Text size="small" maxLines={1}>
          {category}
        </Text>
      </Box>
    ))}
  </Inline>
);
